<template>
  <div class="home">
    <FilterLayout v-model="searchForm" @onSubmit="onSubmit" ref="filterLayout">
      <el-col :md="6" :sm="12">
        <el-form-item label="包名/权限" prop="val">
          <el-input
            v-model.trim="searchForm.val"
            placeholder="请输入包名/权限"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :md="6" :sm="12">
        <el-form-item label="类别" prop="type" multiple collapse-tags>
          <el-select v-model="searchForm.type" placeholder="请选择">
            <el-option label="全部" value="all"> </el-option>
            <el-option label="包名" value="pkg_name"> </el-option>
            <el-option label="权限" value="sdk_auth"> </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-button @click="initFrom" slot="btn-option">重置筛选</el-button>
    </FilterLayout>
    <div class="table-header">
      <div style="margin-right: 10px">
        <el-button type="primary" @click="addData">新增注释</el-button>
        <el-button type="primary" @click="delAll">批量删除</el-button>
      </div>
      <div style="margin: 0 20x">
        <el-button type="primary" @click="leadingOut" :loading="loading"
          >导出</el-button
        >
      </div>
    </div>
    <div style="display: flex">
      <el-table
        style="width: 50%"
        ref="multipleTable"
        :data="tableData.data1"
        tooltip-effect="dark"
        :stripe="false"
        @selection-change="handleSelectionChange"
        v-loading="tableData.loading"
      >
        <el-table-column type="selection" align="center" width="55">
        </el-table-column>
        <el-table-column prop="val" align="center" label="包名/权限">
        </el-table-column>
        <el-table-column prop="label" align="center" label="注释">
        </el-table-column>
        <el-table-column prop="type" align="center" label="类别">
          <template slot-scope="scope">
            {{ scope.row.type === "pkg_name" ? "包名" : "权限" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="delData(scope.row)"
              >删除</el-button
            >
            <el-button type="text" size="small" @click="changeData(scope.row)"
              >修改</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-table
        style="width: 50%"
        ref="multipleTable"
        :data="tableData.data2"
        tooltip-effect="dark"
        :stripe="false"
        @selection-change="handleSelectionChange2"
        v-loading="tableData.loading"
      >
        <el-table-column type="selection" align="center" width="55">
        </el-table-column>
        <el-table-column prop="val" align="center" label="包名/权限">
        </el-table-column>
        <el-table-column prop="label" align="center" label="注释">
        </el-table-column>
        <el-table-column prop="type" align="center" label="类别">
          <template slot-scope="scope">
            {{ scope.row.type === "pkg_name" ? "包名" : "权限" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="delData(scope.row)"
              >删除</el-button
            >
            <el-button type="text" size="small" @click="changeData(scope.row)"
              >修改</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="table-footer">
      <el-pagination
        background
        layout="total, prev, pager, next, jumper"
        :total="tableData.total"
        :current-page="tableData.currentPage"
        @current-change="onPageChange"
        :page-size="20"
      ></el-pagination>
    </div>

    <el-dialog
      :title="changFlag ? '修改注释' : '新增注释'"
      :visible.sync="addVisible"
    >
      <el-form
        ref="addForm"
        :model="addForm"
        label-width="120px"
        :rules="addRules"
        class="custom-form"
      >
        <el-form-item label="类别" prop="type">
          <el-input v-if="loginId == '304'" v-model.trim="addForm.type" placeholder="请输入类别"></el-input>
          <el-select v-model="addForm.type" placeholder="请选择" v-else>
            <el-option label="包名" value="pkg_name"> </el-option>
            <el-option label="权限" value="sdk_auth"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="包名/权限" prop="val">
          <el-input v-model.trim="addForm.val" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="注释" prop="label">
          <el-input v-model.trim="addForm.label" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="onAdd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import FormatJson from "@/util/lead-out/FormatJson";
import { export_json_to_excel } from "@/util/lead-out/Export2Excel";
import FilterLayout from "@/layout/form";
import TableLayout from "@/layout/table";
import SelectApp from "@/component/select-apps";
import SelectCustomize from "@/component/select-customize";
import store from "store2";
export default {
  components: {
    FilterLayout,
    TableLayout,
    SelectApp,
    SelectCustomize,
  },
  computed: {
    ...mapState({
      appArr: (state) => state.app.data,
    }),
  },
  data() {
    return {
      searchForm: {
        val: "",
        type: "all",
      },
      department_id: [],
      addClassify_id: [],
      addClassifyInfo: {
        appInfo: [],
      },
      departmentInfo: {
        appInfo: [],
      },
      column: [
        {
          prop: "val",
          label: "包名/权限",
        },
        {
          prop: "label",
          label: "注释",
        },
        {
          prop: "type",
          label: "类别",
        },
      ],
      tableOpt: {
        currentPage: 1,
        pageSize: 20,
      },
      tableData: {
        loading: false,
        data: [],
      },
      configList: [],
      addVisible: false,
      addForm: {
        val: "",
        label: "",
        type: "",
      },
      addRules: {
        type: [{ required: true, message: "请选择类别" }],
        val: [{ required: true, message: "请填写包名/权限" }],
        label: [{ required: true, message: "请填写注释" }],
      },
      changFlag: false,
      nowId: "",
      loading: false,
      multipleSelection: [],
      multipleSelection2: [],
      loginId:""
    };
  },
  mounted() {
    this.getReport();
    let { loginToken = "", user = {} } = store.getAll();
    if (user.id) {
      this.loginId = user.id
    }
  },
  methods: {
    async onSubmit() {
      this.tableData.loading = true;
      const { searchForm, tableOpt } = this;
      const [err, res] = await this.$http.post("data_dict/list", {
        val: searchForm.val,
        type: searchForm.type === "all"?['pkg_name','sdk_auth']:searchForm.type,
        currentPage: 1,
        pageSize: 20,
      });
      this.tableData.loading = false;

      if (err || res.list === null) {
        this.tableData = {
          list: [],
          total: 0,
          currentPage: 1,
          pageSize: 20,
          loading: false,
        };
        return;
      }
      const { list, currentPage, total } = res;
      let arr = this.group(list, 10);
      this.tableData.data1 = arr[0];
      this.tableData.data2 = arr[1];
      this.tableData.total = total;
    },
    initFrom() {
      /* this.searchForm.val = "";
      this.searchForm.type = ""; */
      this.$refs.filterLayout.$refs.searchForm.resetFields()
      this.departmentInfo.appInfo = [];
      this.tableData.currentPage = 1;
      this.tableOpt.currentPage = 1;
      this.getReport();
    },
    async getReport() {
      this.tableData.loading = true;
      const { searchForm, tableOpt } = this;
      const [err, res] = await this.$http.post("data_dict/list", {
        val: searchForm.val,
        type: searchForm.type === "all"?['pkg_name','sdk_auth']:searchForm.type,
        ...tableOpt,
      });
      this.tableData.loading = false;
      if (err || res.list === null) {
        this.tableData = {
          list: [],
          total: 0,
          currentPage: 1,
          pageSize: 20,
          loading: false,
        };
        return;
      }
      const { list, currentPage, total } = res;
      let arr = this.group(list, 10);
      this.tableData.data1 = arr[0];
      this.tableData.data2 = arr[1];
      this.tableData.total = total;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSelectionChange2(val) {
      this.multipleSelection2 = val;
    },
    onPageChange(current) {
      this.tableData.currentPage = current;
      this.tableOpt.currentPage = current;
      this.getReport();
    },
    async delAll() {
      let id = this.multipleSelection.map((item) => {
        return item.id;
      });
      let id2 = this.multipleSelection2.map((item) => {
        return item.id;
      });
      if (id.length == 0 && id2.length == 0) {
        return;
      }
      this.$confirm("确认删除所选注释？").then(async (_) => {
        this.tableData.loading = true;
        const [err, res] = await this.$http.post("data_dict/del", {
          id: [...id, ...id2],
        });
        if (err) return;
        this.$message({
          message: "删除成功",
          type: "success",
        });
        this.getReport();
      });
    },
    delData(data) {
      this.$confirm("确认删除当前注释？").then(async (_) => {
        this.tableData.loading = true;
        const [err, res] = await this.$http.post("data_dict/del", {
          id: data.id,
        });
        if (err) return;
        this.$message({
          message: "删除成功",
          type: "success",
        });
        this.getReport();
      });
    },
    changeData(data) {
      this.changFlag = true;
      this.addVisible = true;
      this.addForm.val = data.val;
      this.addForm.label = data.label;
      this.addForm.type = data.type;
      this.nowId = data.id;
      console.log(this.addForm);
    },
    addData() {
      this.changFlag = false;
      this.addVisible = true;
      if (this.$refs["addForm"] !== undefined) {
        this.$refs.addForm.resetFields();
      }
    },
    // 导出
    async leadingOut() {
      const { column, searchForm, tableOpt } = this;

      if (!column.length) return;

      this.loading = true;

      const [err, res] = await this.$http.post("data_dict/list", {
        val: searchForm.val,
        label: searchForm.label,
        type: searchForm.type,
        download: true,
        currentPage: 1,
      });

      if (err) {
        this.$notify.error({
          title: "导出提示",
          message: err,
        });
        this.loading = false;

        return;
      }
      let arr = [];
      arr.push(...res.list);

      for (let index = 1; index < res.last_page; index++) {
        const [err, res] = await this.$http.post("data_dict/list", {
          val: searchForm.val,
          label: searchForm.label,
          type: searchForm.type,
          download: true,
          currentPage: index + 1,
        });
        arr.push(...res.list);
      }
      this.loading = false;

      const data = arr;

      if (!data || !data.length) {
        this.$notify.error({
          title: "导出提示",
          message: "未查询到数据，请更换搜索条件重新查询",
        });
        return;
      }

      let app = this.$route.query.appId;
      let currentApp = {};
      let appName = "";
      let appSystem = "";

      if (app) {
        currentApp = this.appArr.filter((v) => v.id === app)[0];
        appName = currentApp["title"];
        appSystem = currentApp["system"] === "1" ? "[安卓]" : "[苹果]";
      }

      const menu = this.$route.meta.name;
      data.forEach((item) => {
        if (item.type === "pkg_name") {
          item.type = "包名";
        } else {
          item.type = "权限";
        }
      });
      const tHeader = column.map((v) => v.label);
      const filter = column.map((v) => v.prop);
      const _data = FormatJson(filter, data);

      export_json_to_excel(tHeader, _data, `项目中台-包名/权限注释维护`);
    },
    onAdd() {
      if (this.changFlag) {
        this.$refs.addForm.validate(async (v, i) => {
          if (v) {
            const { addForm } = this;
            console.log(addForm);
            const [err, res] = await this.$http.post("data_dict/add_change", {
              id: this.nowId,
              val: addForm.val,
              label: addForm.label,
              type: addForm.type,
            });
            if (err) {
              return;
            }
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.$refs.addForm.resetFields();
            this.addVisible = false;
            this.getReport();
          } else {
            return;
          }
        });
      } else {
        this.$refs.addForm.validate(async (v, i) => {
          if (v) {
            const { addForm } = this;
            console.log(addForm);
            const [err, res] = await this.$http.post("data_dict/add_change", {
              val: addForm.val,
              label: addForm.label,
              type: addForm.type,
            });
            if (err) {
              return;
            }
            this.$message({
              message: "新增成功",
              type: "success",
            });
            this.$refs.addForm.resetFields();
            this.addVisible = false;
            this.getReport();
          } else {
            return;
          }
        });
      }
    },
    group(array, subGroupLength) {
      let index = 0;
      let newArray = [];
      while (index < array.length) {
        newArray.push(array.slice(index, (index += subGroupLength)));
      }
      return newArray;
    },
  },
};
</script>

<style lang="less" scoped>
.table-header {
  margin: 20px 0;
  display: flex;
}
.table-footer {
  display: flex;
  flex-direction: row-reverse;
  background-color: #fff;
  padding: 20px;
}
</style>
